import {
  LOAD_GROUPS,
  LOAD_GROUPS_FAIL,
  LOAD_GROUPS_SUCCESS,
  ADDING_GROUP,
  END_ACTION,
  ADD_GROUP_REQUEST,
  SAVE_GROUP_REQUEST,
  EDITING_GROUP_FORM,
  EDITING_GROUP,
  GroupsAction,
} from "./actionTypes";
import { AsyncAction } from "../../store";
import { GroupData } from "./reducer";

export const loadGroups = (
  user: Insite.AppState["auth"]["user"],
  lookup = false
): AsyncAction => {
  let url = "/groups";
  if (lookup) url = `${url}/lookup`;
  return {
    types: [LOAD_GROUPS, LOAD_GROUPS_SUCCESS, LOAD_GROUPS_FAIL],
    promise: (client) =>
      client.get(url, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        params: {
          role: user.role,
        },
      }),
  };
};

export function startAddGroup(): GroupsAction {
  return { type: ADDING_GROUP };
}

export function handleClose(): GroupsAction {
  return { type: END_ACTION };
}

// TODO: Why does this exist?
export function handleSubmit(func: any) {
  return func();
}

export function addGroupRequest() {
  return { type: ADD_GROUP_REQUEST };
}

export function saveGroupRequest() {
  return { type: SAVE_GROUP_REQUEST };
}

export function startEditGroup(row: GroupData) {
  return { type: EDITING_GROUP, row };
}

export const handleChange = (
  e: React.SyntheticEvent<HTMLInputElement>,
  inputId: string | null = null
) => {
  let inputValue = {};

  if (!inputId) {
    inputId = e.currentTarget.id;
    if (e.currentTarget.type === "checkbox") {
      inputValue = e.currentTarget.checked;
    } else {
      inputValue = e.currentTarget.value;
    }
  } else {
    inputValue = e;
  }

  return {
    type: EDITING_GROUP_FORM,
    input_id: inputId,
    input_value: inputValue,
  };
};
